import { ICampaignDeliveryType } from "../interfaces/campaign/campaign-delivery-type.model.interface";

export class CampaignDeliveryTypeModel implements ICampaignDeliveryType {
    public campaignDeliveryTypeId: number;
    public name: string;

    constructor(campaignDeliveryTypeId: number, name: string) {
        this.campaignDeliveryTypeId = campaignDeliveryTypeId;
        this.name = name;
    }
}
